import { getChangeLogApiCall } from '../../entities/ChangeLog/ChangeLogService'
import { isFetchCollectionResultSuccessful } from '../../entities/FetchResult'
import { TypedDispatch } from '../store'
import { setChangeLogEntries, setError, setIsLoading } from './changeLogEntriesReducer'

export const getChangeLogEntries = () => async (dispatch: TypedDispatch): Promise<void> => {
    dispatch(setIsLoading(true))
    dispatch(setError(''))

    try {
        const response = await getChangeLogApiCall()

        if (! isFetchCollectionResultSuccessful(response)) {
            dispatch(setError(response.error))

            return
        }

        dispatch(setChangeLogEntries(response.data))
    } catch (error) {
        console.error('[getChangeLogEntries]', error)
    } finally {
        dispatch(setIsLoading(false))
    }
}
